import { IState } from '../types';
import { useSelector } from 'react-redux';

export function useSupportsDeepLinksV1(): boolean {
  return useSelector((state: IState) => state.supportsDeepLinksV1);
}
